<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card>

        <div class="vx-card__title mb-6">
          <h2 class="text-center">{{projectInfo.title}} 프로젝트 에</h2>
          <h2 class="text-center">멤버을 초대합니다.</h2>
        </div>

        <img src="@/assets/images/pages/rocket.png" alt="coming-soon" class="mx-auto mb-2" width="150">

        <div class="count-down text-center">
          <!-- <countdown :time="new Date('03/09/2021 00:00:00').getTime() - new Date().getTime()">

            <template slot-scope="props">

              <div class="single-counter">
                <span class="timer">{{ props.days }}</span>
                <span>Days</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.hours }}</span>
                <span>Hours</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.minutes }}</span>
                <span>Minutes</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.seconds }}</span>
                <span>Seconds</span>
              </div>

            </template>
          </countdown> -->
          <div>
            <p> 초대할 멤버의 Email을 입력해보세요 </p> <br>
            <vs-textarea placeholder="예) user01@filledyou.com; user02@google.com" v-model="emails"/>
          </div>
        </div>
        <vs-divider position="center">Subscribe</vs-divider>
        <div class="subscription">
          <span>문의사항:mesen@filledyou.com</span>
          <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-4" /> -->

        </div>
        <vs-button color="primary" type="flat" @click="skip()">Skip</vs-button>
        <vs-button color="primary" type="flat" @click="done()">완료</vs-button>
      </vx-card>
    </div>
  </div>
</template>


<script>

export default {
  data() {
    return {
      emails: ''
    }
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.ActiveProjectInfo
    }
},
  methods: {
    skip() {
      // TODO :: 프로젝트 URL로 이동 필요.
      this.$router.push('/apps/space')
    },
    done() {
      this.$vs.loading()
      const payload = {
          emails: this.emails,
          projectId: this.projectInfo.id
      }
      this.$store.dispatch('project/inviteProject', payload)
      .then((resolve)=>{
        this.$vs.loading.close()
        if(resolve.data.result == 'success'){
          this.$vs.notify({
            color: 'success',
            title: '초대 완료'
          })
        }
        this.$router.push('/apps/space')
      }).catch((error) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      // const payload = {
      //   title: this.spaceName,
      //   detail: this.spaceDetail
      // }
      // console.log('done')
      // this.$store.dispatch('space/createSpace', payload)
    }
  }
}

</script>
